import axios from "axios";

import APIClient from "../client";
import store from "../../store";
import { sliceActions as authActions } from "../../store/auth-slice";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const instance = axios.create({
  baseURL: BASE_URL,
});

export const registerAPI = async (credentials, captcha = null) => {
  try {
    const response = await instance.post("/auth/register", credentials, {
      headers: {
        "Content-Type": "application/json",
        "Recaptcha-Response": captcha,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message;
  }
};

export const loginAPI = async (credentials, captcha = null) => {
  return instance.post("/auth/login", credentials, {
    headers: {
      "Content-Type": "application/json",
      "Recaptcha-Response": captcha,
    },
  });
};

export const refreshTokenAPI = async (refreshToken) => {
  try {
    const response = await instance.post("/auth/refresh-token", null, {
      headers: {
        "Content-Type": "application/json",
        "Refresh-Token": refreshToken,
      },
    });
    if (response && response.data) {
      localStorage.setItem("refresh", response.data.refreshToken);
    }
    return response.data;
  } catch (error) {
    console.log(error.response?.data?.message);
  }
};

export const setPasswordAPI = async (passwords, token) => {
  try {
    await instance.post(`/auth/confirm?token=${token}`, passwords);
  } catch (error) {
    throw error.response?.data?.message;
  }
};

export const logoutAPi = async () => {
  try {
    await APIClient.post("/auth/logout");
    store.dispatch(authActions.setAccessToken(""));
    localStorage.removeItem("refresh");
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};

export const resetPasswordAPI = async (passwords, token, captcha = null) => {
  return APIClient.post(
    "/auth/reset-password",
    { token, ...passwords },
    {
      headers: {
        "Content-Type": "application/json",
        "Recaptcha-Response": captcha,
      },
    }
  );
};

export const forgotPasswordAPI = (email, captcha = null) => {
  return instance.post("/auth/forgot-password", email, {
    headers: {
      "Content-Type": "application/json",
      "Recaptcha-Response": captcha,
    },
  });
};

export const validateConfirmTokenAPI = (token) => {
  return APIClient.get(`/auth/validate-token?token=${token}`);
};

export const validateResetTokenAPI = (token) => {
  return APIClient.get(`/auth/validate-reset-token?token=${token}`);
};
